import * as ClassList from './methods/class-list.js';
import * as ContextMethods from './methods/context.js';
export { ContextMethods };
export const Context = Object.assign({}, ContextMethods, {
    // moved here to avoid circular imports
    getClassList(context, ...extraClasses) {
        const classList = context
            ? Array.isArray(context)
                ? context
                : ClassList.fromClassName(ContextMethods.getClassName(context))
            : [];
        if (extraClasses.length)
            return ClassList.concat(classList, extraClasses);
        return classList;
    },
    getDefinition(context) {
        return ClassList.getDefinition(context instanceof Array ? context : Context.getClassList(context));
    }
});
//# sourceMappingURL=context.js.map